import { useEffect } from 'react';
import { useTenantContext } from '@trashlab/sitesapp/src/contexts/use-tenant-context';
import env from '@trashlab/sitesapp/src/env';

declare global {
  interface Window {
    initChatWidget: () => void;
  }
}

const getChatScriptUrl = () => {
  if (!env.isProd) {
    return new URL('/chat-button.js', env.NEXT_PUBLIC_APP_HOST).toString();
  }

  // Production: all sitesapp websites (any domain) use the main app's chat script
  return 'https://app.trashlab.com/chat-button.js';
};

export const ChatWidget = () => {
  const { website } = useTenantContext();

  useEffect(() => {
    if (!website?.organization.id) return;

    const loadChatWidget = () => {
      const existingScript = document.getElementById(website.organization.id);
      if (existingScript) {
        existingScript.remove();
      }

      const script = document.createElement('script');
      script.id = website.organization.id;
      script.src = getChatScriptUrl();
      script.defer = true;
      script.async = true;

      document.body.appendChild(script);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadChatWidget);
    } else {
      loadChatWidget();
    }

    return () => {
      const script = document.getElementById(website.organization.id);
      if (script) {
        script.remove();
      }
      document.removeEventListener('DOMContentLoaded', loadChatWidget);
    };
  }, [website?.organization.id]);

  return null;
};
